@let testIdPrefix = 'rcp-toast-alert';
<div
    class="rcp-toast-container"
    [attr.data-testid]="testIdPrefix"
>
    @for (toast of toasts(); track toast.id) {
        <div
            class="rcp-text-text-high-contrast rcp-flex rcp-w-full rcp-flex-col rcp-gap-0 rcp-border-l-[4px] rcp-text-[14px] rcp-leading-[20px] rcp-tracking-[0.1px] md:rcp-w-[312px]"
            [@slideInOut]
            [ngClass]="getToastContainerClasses(toast.type)"
        >
            <div class="rcp-flex rcp-w-full rcp-flex-row md:rcp-w-auto">
                <div
                    class="rcp-flex rcp-h-[56px] rcp-w-[56px] rcp-items-center rcp-justify-center"
                >
                    <mat-icon
                        [fontIcon]="getToastIcon(toast.type)"
                        [ngClass]="getToastIconClasses(toast.type)"
                        [attr.data-testid]="
                            toastTypes[toast.type] | testid: testIdPrefix : 'icon'
                        "
                    ></mat-icon>
                </div>
                <div class="rcp-flex rcp-flex-grow rcp-items-center md:rcp-w-[204px]">
                    <p class="rcp-font-[Poppins] rcp-font-[500]">{{ toast.title }}</p>
                </div>
                <div class="rcp-flex rcp-w-[48px] rcp-items-center rcp-justify-center">
                    <mat-icon
                        tabindex="0"
                        class="rcp-h-[40px] rcp-w-[44px]"
                        fontIcon="close"
                        [attr.data-testid]="
                            toastTypes[toast.type] | testid: testIdPrefix : 'close-btn'
                        "
                        (click)="dismissToast(toast.id)"
                        (keyup.enter)="dismissToast(toast.id)"
                        (keyup.space)="dismissToast(toast.id)"
                    ></mat-icon>
                </div>
            </div>
            <div class="rcp-flex rcp-w-full rcp-flex-row md:rcp-w-auto">
                <div
                    class="rcp-mb-[24px] rcp-ml-[56px] rcp-mr-[48px] rcp-flex rcp-w-full md:rcp-mr-0 md:rcp-w-[236px]"
                >
                    <p
                        class="rcp-font-['Open_Sans'] rcp-font-[400]"
                        [attr.data-testid]="
                            toastTypes[toast.type] | testid: testIdPrefix : 'description'
                        "
                    >
                        {{ toast.message }}
                    </p>
                </div>
            </div>
        </div>
    }
</div>
